import TransferWindow from '@cohort/wallet/components/space/nftTransfer/TransferWindow';
import {useOwnership} from '@cohort/wallet/hooks/api/Ownerships';
import useNotify from '@cohort/wallet/hooks/notify';
import useSpaceContext from '@cohort/wallet/hooks/useSpaceContext';
import SpacePage from '@cohort/wallet/layouts/space/SpacePage';
import {getMerchantSpaceRoute, getNftDetailRoute} from '@cohort/wallet/lib/Pages';
import AboutDigitalAssetPanel from '@cohort/wallet/pages/space/AboutDigitalAssetPanel';
import React, {Fragment, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate, useParams} from 'react-router-dom';

const NewTransferPage: React.FC = () => {
  const {space} = useSpaceContext();
  const {t} = useTranslation('pages', {keyPrefix: 'space.newTransferPage'});
  const navigate = useNavigate();
  const {ownershipId} = useParams();
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const {data: ownership, isFetched} = useOwnership(ownershipId!, ownershipId !== undefined);
  const notify = useNotify();

  useEffect(() => {
    if (ownership === undefined && isFetched) {
      navigate(getMerchantSpaceRoute());
      return;
    }
    if (ownership && !ownership.canBeTransferred) {
      navigate(getNftDetailRoute(ownership.id));
      return;
    }
    if (ownership?.status === 'transferred') {
      notify('error', t('nftAlreadySent'), {autoClose: false});
      navigate(getMerchantSpaceRoute(), {replace: true});
    }
  }, [navigate, ownership, space, t, notify, isFetched]);

  if (space === undefined || ownership === undefined) {
    return <Fragment />;
  }

  return (
    <SpacePage
      title={t('pageTitle')}
      tracking={{
        namespace: 'digitalAssets.transfer.new',
        metadata: {
          ownershipId: ownership.id,
        },
      }}
      leftPanel={<AboutDigitalAssetPanel ownership={ownership} />}
    >
      <TransferWindow ownership={ownership} />
    </SpacePage>
  );
};

export default NewTransferPage;
